import { useEffect, useState } from 'react'
import { UsersRound } from 'lucide-react'
import Button from '../../components/Button'
import { FormBody, InfoNote } from '../../components/Form'
import FormRow from '../../components/FormRow'
import Modal from '../../components/Modal'
import Select from '../../components/Select'
import { strings as S } from './strings'
import './modals.css'

const C = S.clone

/**
 * سحب المستخدمين من مصدر الربط — `/Users/Clone`.
 *
 * The users half of the departments modal next door, and the same story: the endpoint and
 * its service function have been here since the slice was wired, offered by nothing, while
 * the page payload carried `DataSources` that nothing read.
 *
 * The source is CHOSEN rather than assumed — one configured directory is the normal case,
 * but the payload returns a list and the wrong one imports the wrong organisation.
 */
export default function UserCloneModal({ open, sources, onClose, onSubmit, saving }) {
  const [sourceId, setSourceId] = useState('')

  // Preselect when there is only one: the choice is real, but it should not be busywork.
  useEffect(() => {
    if (!open) return
    setSourceId(sources?.length === 1 ? String(sources[0].id) : '')
  }, [open, sources])

  const options = (sources ?? []).map((source) => ({
    value: String(source.id),
    label: source.name,
  }))

  return (
    <Modal
      open={open}
      size="sm"
      title={C.title}
      icon={UsersRound}
      hint={C.hint}
      onClose={onClose}
      footer={
        <Button disabled={!sourceId || saving} onClick={() => onSubmit(sourceId)}>
          {saving ? C.running : C.submit}
        </Button>
      }
    >
      <FormBody>
        <FormRow label={C.source}>
          {(id) => (
            <Select
              id={id}
              value={sourceId}
              onChange={setSourceId}
              options={options}
              placeholder={C.sourcePlaceholder}
            />
          )}
        </FormRow>

        {/* The selected integration mode and resignation policy govern this operation. */}
        <InfoNote>
          <bdi>{C.note}</bdi>
        </InfoNote>
      </FormBody>
    </Modal>
  )
}
